import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, DatePicker, Flex, Form, Input, Modal, notification, Radio, RadioChangeEvent, Select, FormInstance, FormProps, AutoComplete } from 'antd'
import './AddRelative.scss'
import * as  selectOptionsApi from '../../../api/selectOptions/selectOptionsApi'
import { fommatSelectOption, handleDateChangeDayJs } from '../../../until'
import dayjs, { Dayjs } from "dayjs";
import { getListProfession } from '../../../api/profession/professionApi'
import useToast from '../../../hook/useToast'
import { useForm } from 'antd/es/form/Form'
import { set, values } from 'lodash'
import useThrottle from '../../../hook/useThrottle'
import { getInfoCustomer, ICustomerDetail_V2, ICustomerDetail_V4 } from '../../../api/customer/customerApi'
import { addRelativeCustomer_V2, addRelativeCustomer_V3, addRelativeCustomer_V4, IPhone } from '../../../api/relatives/relativesApi'
import { selectorInfoUser } from '../../../store/slices/infoUserSlice'
import { useSelector } from 'react-redux'
import { PhoneOutlined, PlusSquareOutlined, QuestionOutlined } from '@ant-design/icons'
import { ho_chieu, icon_delelte } from '../../../components/ExportImgFigma'
import { dataTypeDocument, genders } from '../../../services/data'
import { InforSelectedCodeCustomer, IRelationshipADD_V2 } from './AddRelativeAddCustomer'
import { selectorCategoryCarIds } from '../../../store/slices/categoryCarSlice'
import useLoading from '../../../hook/useLoading'
import useDebounce from '../../../hook/useDebounce'


interface CustomerFilterSearch {
  searchBusinessFieldId?: string;
  searchProvince?: string;
  searchDistrict?: string
  searchProfession?: string
  searchPersonContact?: string

}

interface Props {
  show: boolean
  infoCustomer?: ICustomerDetail_V4;
  modalClose?: () => void
  onSuccess?: () => void
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void
}

const AddRelativeModal: React.FC<Props> = (props) => {
  const { show, infoCustomer, modalClose, onSuccess, onSubmitFormModal } = props
  const formRef: any = useRef(null)
  const [form] = useForm()
  const inputRef = useRef<FormInstance>(null);
  const { unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const pushToast = useToast();
  const pushLoading = useLoading();

  const [inforSelectedCodeCustomer, setInforSelectedCodeCustomer] = useState<InforSelectedCodeCustomer>()

  const [sLCodeCustomer, setSLCodeCustomer] = useState<selectOptionsApi.ICodeCustomer[]>([])
  const [sLRelative, setSLRelative] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProfession, setSLProfession] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProvice, setSLProvice] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLDistrict, setSLDistrict] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLTypePhone, setSLTypePhone] = useState<selectOptionsApi.ISelectOption[]>([])

  const [phoneTypeTmp, setPhoneTypeTmp] = useState<{ [key: number]: number }>({})
  const [birthday, setBirthday] = useState<string>()
  const [provice, setProvice] = useState<number>()
  const [district, setDistrict] = useState<number>()
  const [paginationCodeCustomer, setPaginationCodeCustomer] = useState({ current: 1, pageSize: 30, total: 0 });
  const [searchFilter, setSearchFilter] = useState<CustomerFilterSearch>()


  const isDisable = useMemo(() => {
    return inforSelectedCodeCustomer !== undefined;
  }, [inforSelectedCodeCustomer]);

  const gSListCodeCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await selectOptionsApi.getListCodeCustomer(
      permittedCategoryCarIds,
      undefined, searchFilter?.searchPersonContact, undefined, undefined, 30, current
    );
    if (result?.status) {
      // Append nếu current > 1
      setSLCodeCustomer(prev =>
        current === 1
          ? result.data                // load lần đầu
          : [...prev, ...result.data]  // append
      );

      setPaginationCodeCustomer(prev => ({
        ...prev,
        current,
        total: result.total || 0
      }));
    }
    pushLoading(false)
  }, 300)


  const gSListRelatives = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListRelatives();
    if (result?.status) {
      setSLRelative(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLProfession = useDebounce(async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getCLProfession(searchFilter?.searchProfession);
    if (result?.status) {
      setSLProfession(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }, 500)

  const gSLProvice = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListProvince();
    if (result?.status) {
      setSLProvice(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLDistrict = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListDistrict(Number(provice));
    if (result?.status) {
      setSLDistrict(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLTypePhone = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }
  const gInfoCustomer = async () => {
    pushLoading(true)
    form.resetFields()
    const result = await getInfoCustomer(Number(inforSelectedCodeCustomer?.id))
    if (result?.status) {
      const { userName, gender, phone, CCCD, profession, email, relativeId } = result.data

      form.setFieldsValue({
        "personContactId": inforSelectedCodeCustomer?.value,
        "username": userName[0]?.username,
        "gender": gender,
        "phone": phone,
        "CCCD": CCCD,
        "professionId": profession?.id,
        "email": email,
        "relativeId": relativeId,
      });
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const handleSelectCodeCustomer = (value: InforSelectedCodeCustomer) => {
    setInforSelectedCodeCustomer(value)
  }

  const onPopupScroll = (e: any) => {
    const target = e.target;

    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 20;

    if (!isBottom) return;

    const { current, total } = paginationCodeCustomer;
    const hasMore = sLCodeCustomer.length < total;

    if (!hasMore) return;

    gSListCodeCustomer(current + 1);
  };

  const submitForm = useThrottle(() => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  }, 2000);

  const confimSubmit: FormProps["onFinish"] = async (values: any) => {
    const {
      personContactId, username, gender, CCCD, professionId, relativeId, phone, email
    } = values;

    const validEmail = email.map((item: any) => item?.email).filter((email: any) => typeof email === "string" && email.trim() !== "");

    //    businessCheck, username, phone, informationChannel,
    // type, unitTempId, CCCD, gender,
    // statusMarital, listTypes, professionId, birthday,
    // email, contactMethod, carLine, address,
    // image, groupCustomerId, hobbyId, isRelative,
    // customerId, relativeId, description, taxCode,
    // foundingDate, businessFieldId, personContactId
    const result = await addRelativeCustomer_V4(
      0, username, phone,
      undefined, undefined, unitTemp, CCCD, gender, undefined,
      undefined, professionId, undefined,
      validEmail, undefined, undefined, undefined,
      undefined, undefined, undefined, 1,
      Number(infoCustomer?.id), relativeId, undefined, undefined,
      undefined, undefined, inforSelectedCodeCustomer?.id
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }

  }

  const handleResetAll = () => {
    form.resetFields()

    setInforSelectedCodeCustomer(undefined)
  }

  // NOTIFICATION
  const [selectedGender, setSelectedGender] = useState('nam')
  const onChangeGender = ({ target: { value } }: RadioChangeEvent) => {
    setSelectedGender(value)
  }

  useEffect(() => {
    if (inforSelectedCodeCustomer?.id) {
      gInfoCustomer()
    }
  }, [inforSelectedCodeCustomer])


  useEffect(() => {
    if (show)
      gSLProfession()

  }, [searchFilter?.searchProfession])


  useEffect(() => {
    if (show)
      gSListCodeCustomer(1)
  }, [searchFilter?.searchPersonContact])

  useEffect(() => {
    if (show) {
      setSLCodeCustomer([]);
      setPaginationCodeCustomer({ current: 1, pageSize: 30, total: 0 });
      gSListCodeCustomer(1);

      if (!sLRelative.length)
        gSListRelatives()
      if (!sLProfession.length)
        gSLProfession()
      if (!sLProvice.length)
        gSLProvice()
      if (!sLTypePhone.length)
        gSLTypePhone()

    } else {
      form.resetFields()
      setProvice(undefined)
      setDistrict(undefined)
      setBirthday(undefined)
      setPhoneTypeTmp({})
      setInforSelectedCodeCustomer(undefined)
      // setSLRelative([])
      // setSLProfession([])
      // setSLProvice([])
      setSLDistrict([])
    }
  }, [show])

  useEffect(() => {
    form.setFieldValue("quan", undefined)
    setDistrict(undefined)
    if (provice) {
      gSLDistrict()
    }
    else {
      setSLDistrict([])
    }
  }, [provice])

  return (

    <Modal
      open={show}
      title='Thêm người liên hệ'
      className='rs-modal w-572 footer-content-end add-relative-modal'
      centered
      footer={
        <>
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={handleResetAll}
          >Làm mới</Button>
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={submitForm}
          >Lưu</Button>
        </>

      }
      onCancel={modalClose}
    >
      <Form
        form={form}
        ref={inputRef}
        className='rs-form add-relative-form'
        onFinish={confimSubmit}
      >
        <div className="d-flex flex-column gap-2">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Mã định danh khách hàng :
          </p>
          <Form.Item
            layout='vertical'
            name="personContactId"
          >
            <AutoComplete
              disabled={isDisable}
              onPopupScroll={onPopupScroll}
              placeholder="Mã định danh khách hàng"
              options={sLCodeCustomer.map((item) => ({
                value: item.code,         // Giá trị hiển thị trong ô tìm kiếm
                label: `${item.code} - ${item.username}`, // Gợi ý hiển thị dropdown
                id: item.id,              // Giá trị thực tế bạn muốn lấy khi chọn
              }))}
              showSearch
              filterOption={false}
              onSearch={(value) => setSearchFilter({ ...searchFilter, searchPersonContact: value })}
              onBlur={() => {
                // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                setSearchFilter({ ...searchFilter, searchPersonContact: '' }); // Nếu muốn reset khi blur

              }}
              onSelect={(value, option) => {
                handleSelectCodeCustomer(option)
              }}
            >
              <Input className="custom-input-css custom-page-css border" />
            </AutoComplete>
          </Form.Item>
        </div>
        <div className="d-flex flex-column gap-1 pb-2">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Họ và tên
            <div>
              <span className="text-F5222D">*</span>
              :
            </div>

          </p>
          <Form.Item
            layout='vertical'
            // label='Họ và tên'
            name='username'
            rules={[
              { required: true, message: "Vui lòng nhập Họ và tên" }
            ]}
          >
            <Input
              disabled={isDisable}
              placeholder='Họ và tên'
              className='custom-input-css custom-page-css border'
            />
          </Form.Item>
        </div>


        <Form.Item
          label=''
          name='gender'
          rules={[
            { required: false, message: "Vui lòng chọn giới tính" }
          ]}
        >
          <Radio.Group
            className='rs-radio-group gender-group'
          >
            {
              genders.map((item: any) => (
                <Radio.Button
                  disabled={isDisable}
                  key={item.value}
                  value={item.value}
                  className='rs-radio'
                >
                  <span className='inner-text'>{item.icon}{item.label}</span>
                </Radio.Button>
              ))
            }
          </Radio.Group>
        </Form.Item>
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Số điện thoại
            <div>
              <span className="text-F5222D">*</span>
              :
            </div>
          </p>
          <Form.List
            name="phone"
            initialValue={[{ phone: "", categoryPhoneId: null }]}
          >
            {
              (fields, { add, remove }) => (
                <Flex vertical className="gap-10px">
                  {
                    fields.map((field) => (
                      <div key={field.key} className="d-flex gap-1">
                        {/* shouldUpdate để đọc trạng thái categoryPhoneId của từng dòng */}
                        <Form.Item noStyle shouldUpdate>
                          {
                            ({ getFieldValue }) => {
                              const selected = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                              return (
                                <Form.Item
                                  className="w-full"
                                  name={[field.name, "phone"]}
                                  rules={[
                                    { required: true, message: "Vui lòng nhập số điện thoại" },
                                    () => ({
                                      validator(_, value) {
                                        if (!value) return Promise.resolve();

                                        const phoneType = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                                        if (!phoneType) return Promise.resolve();

                                        const isHome = phoneType === 1;
                                        const isCompany = phoneType === 2;

                                        if (isHome && !/^0\d{9}$/.test(value)) {
                                          return Promise.reject(
                                            new Error(
                                              "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)"
                                            )
                                          );
                                        }

                                        if (isCompany && !/^0\d{10,11}$/.test(value)) {
                                          return Promise.reject(
                                            new Error(
                                              "Số điện thoại không hợp lệ (11-12 số, bắt đầu bằng 0)"
                                            )
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                >
                                  <Input
                                    prefix={<PhoneOutlined />}
                                    placeholder="Số điện thoại"
                                    className="custom-input-css custom-page-css border"
                                    type="tel"
                                    disabled={!selected || isDisable} // Chỉ nhập khi đã chọn loại điện thoại
                                  />
                                </Form.Item>
                              );
                            }}
                        </Form.Item>
                        <Form.Item
                          name={[field.name, "categoryPhoneId"]}
                          rules={[{ required: true, message: "Vui lòng chọn loại điện thoại" }]}
                        >
                          <Select
                            disabled={isDisable}
                            options={sLTypePhone}
                            placeholder="Loại điện thoại"
                            className="custom-page-css border rounded overflow-hidden w-150-px"

                            onChange={(val) => {
                              // Nếu bỏ chọn => xóa luôn số điện thoại
                              if (val == null) {
                                const curr = (form?.getFieldValue?.("phone") ?? []).slice();
                                if (curr[field.name]) curr[field.name].phone = "";
                                form?.setFieldsValue?.({ phone: curr });
                              }
                            }}
                          />
                        </Form.Item>
                        <img
                          hidden={fields.length <= 1}
                          src={icon_delelte}
                          alt=""
                          className={`${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                          onClick={() => remove(field.name)} // dùng field.name an toàn hơn index
                        />
                      </div>
                    ))
                  }
                  <div
                    className={`${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"}`}
                    onClick={() => add({ phone: "", categoryPhoneId: null })}
                  >
                    <PlusSquareOutlined className="text-sm" />
                    <span className="text-sm">Thêm số điện thoại mới</span>
                  </div>
                </Flex>
              )
            }
          </Form.List>


        </div>

        {/* <Form.Item
          layout='vertical'
          label='CCCD :'
          name='CCCD'
          rules={[
            {
              pattern: /^\d{12}$/,
              message: 'CCCD phải gồm đúng 12 chữ số',
              validator: (_, value) => {
                if (!value) return Promise.resolve(); // Cho phép bỏ trống
                return /^\d{12}$/.test(value)
                  ? Promise.resolve()
                  : Promise.reject('CCCD phải gồm đúng 12 chữ số');
              }
            }
          ]}
        >
          <Input
            disabled={isDisable}
            placeholder='CCCD'
            className='custom-input-css custom-page-css border'
          />
        </Form.Item> */}
        <div>
          <div className="d-flex gap-1 mb-1">

            {/* INPUT CCCD / PASSPORT */}
            <Form.Item
              shouldUpdate={(prev, cur) =>
                prev?.CCCD?.[0]?.identityType !== cur?.CCCD?.[0]?.identityType
              }
              noStyle
            >
              {({ getFieldValue }) => {
                const typeDoc = getFieldValue(["CCCD", 0, "identityType"]);

                return (
                  <Form.Item
                    className="w-full"
                    name={["CCCD", 0, "name"]}
                    initialValue=""
                    rules={[
                      { required: true, message: "Vui lòng nhập giấy tờ" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const typeDoc = getFieldValue(["CCCD", 0, "identityType"]);

                          if (!typeDoc && typeDoc !== 0) {
                            return Promise.reject(
                              new Error("Vui lòng chọn loại giấy tờ trước")
                            );
                          }

                          if (!value || value.trim() === "") {
                            return Promise.reject(
                              new Error("Vui lòng nhập số giấy tờ")
                            );
                          }

                          if (typeDoc === 0 && !/^\d{12}$/.test(value)) {
                            return Promise.reject(
                              new Error("CCCD phải gồm đúng 12 chữ số")
                            );
                          }

                          const passport = value?.toUpperCase().trim();

                          if (typeDoc === 1 && !/^[A-Z0-9]{6,9}$/.test(passport)) {
                            return Promise.reject(
                              new Error(
                                "Số hộ chiếu không hợp lệ (6–9 ký tự chữ hoặc số)"
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input
                      prefix={<img src={ho_chieu} />}
                      placeholder="Nhập số CCCD/Hộ chiếu"
                      disabled={(!typeDoc && typeDoc !== 0) || isDisable} // ⭐ KEY HERE
                      className="custom-input-css custom-page-css border"
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>

            {/* SELECT TYPE */}
            <Form.Item
              name={["CCCD", 0, "identityType"]}
              initialValue={null}
              rules={[{ required: true, message: "Vui lòng chọn loại" }]}
            >
              <Select
                options={dataTypeDocument}
                disabled={isDisable}
                placeholder="Loại"
                className="custom-page-css border rounded overflow-hidden w-200-px"
                onChange={(val) => {
                  const currentCCCD = form.getFieldValue("CCCD") || [];
                  const currentItem = currentCCCD[0] || {};

                  form.setFieldsValue({
                    CCCD: [
                      {
                        ...currentItem,
                        identityType: val,
                        name: "",
                        isPrimary: 1,
                      },
                    ],
                  });
                }}
              />
            </Form.Item>

          </div>

          {/* Hidden field với giá trị mặc định */}
          <Form.Item name={["CCCD", 0, "isPrimary"]} initialValue={1} hidden>
            <Input type="hidden" />
          </Form.Item>
        </div>
        <Form.Item
          layout='vertical'
          label='Nghề nghiệp :'
          name='professionId'
        // rules={[
        //   { required: true, message: "Vui lòng chọn nghề nghiệp" }
        // ]}
        >
          <Select
            disabled={isDisable}
            placeholder='Nghề nghiệp'
            className='custom-page-css border rounded overflow-hidden'
            showSearch
            filterOption={false}
            onSearch={(value) => setSearchFilter({ ...searchFilter, searchProfession: value })}
            onBlur={() => setSearchFilter({ ...searchFilter, searchProfession: '' })}

            options={sLProfession}
          />
        </Form.Item>
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Email :
          </p>
          <Form.List
            name="email"
            initialValue={[{}]}
          >
            {(fields, { add, remove }) => (
              <div className='d-flex flex-column gap-1'>
                {fields.map((field, i) => (
                  <div key={field.key} className="d-flex gap-2">

                    <Form.Item
                      name={[field.name, 'email']}
                      fieldKey={[i, "email"]}
                      className="m-none-form-item text-explan w-full"
                      rules={[
                        {
                          type: 'email',
                          message: 'Email không hợp lệ',
                        },
                      ]}
                    >
                      <Input
                        disabled={isDisable}
                        placeholder="Email"
                        className="custom-input-css custom-page-css border"
                      />
                    </Form.Item>
                    <img
                      hidden={fields.length <= 1}
                      src={icon_delelte}
                      alt=""
                      className={` ${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                      onClick={() => remove(i)}
                    />
                  </div>
                ))}
                <div
                  className={` ${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"} `}
                  onClick={() => add({})}
                >
                  <PlusSquareOutlined className="text-sm" />
                  <span className="text-sm">Thêm mail mới</span>
                </div>
              </div>
            )}
          </Form.List>
        </div>
        <Form.Item
          layout='vertical'
          label='Mối quan hệ :'
          name='relativeId'
          rules={[
          ]}
        >
          <Select
            placeholder='Mối quan hệ'
            className='custom-page-css border rounded overflow-hidden'

            options={sLRelative}
          />
        </Form.Item>
      </Form>
    </Modal >

  )
}

export default AddRelativeModal
